<template>
    <div>
        <div v-show="parent2Show">
            <h3>门店信息</h3>
            <Row :gutter="2.5" class="hdLiBox">
                <Col span="12" class="hd_li">
                    <p><span>门店ID</span>{{basicsData.stid}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>大区</span>{{basicsData.area}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>省份</span>{{basicsData.province}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>城市群</span>{{basicsData.citys}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>地级市</span>{{basicsData.pcity}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>县级市</span>{{basicsData.ccity}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>一级门店类型</span>{{basicsData.firsttype}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>二级门店类型</span>{{basicsData.secondtype}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>三级门店类型</span>{{basicsData.thirdtype}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店编码</span>{{basicsData.scode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店名称</span>{{basicsData.sname}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店地址</span>{{basicsData.sloction}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>客户类型</span>{{basicsData.customertype}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>客户系列编码</span>{{basicsData.customercode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>客户系列</span>{{basicsData.customer}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>业务员组织编码</span>{{basicsData.salesorganizecode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>业务员编码</span>{{basicsData.salesmancode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>业务员姓名</span>{{basicsData.salesmanname}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>上级主管编码</span>{{basicsData.supervisorcode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>上级主管</span>{{basicsData.supervisor}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店负责人组织编码</span>{{basicsData.responorganizecode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店负责人编码</span>{{basicsData.responcode}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店负责人</span>{{basicsData.responname}}</p>
                </Col>
                <Col span="12" class="hd_li">
                    <p><span>门店类型</span>{{basicsData.stype}}</p>
                </Col>
            </Row>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    export default {
        data(){
            return{
                basicsData:{
                    stid:null,
                    area:null,
                    province:null,
                    citys:null,
                    pcity:null,
                    ccity:null,
                    firsttype:null,
                    secondtype:null,
                    thirdtype:null,
                    scode:null,
                    sname:null,
                    sloction:null,
                    customertype:null,
                    customercode:null,
                    salesorganizecode:null,
                    salesmancode:null,
                    salesmanname:null,
                    supervisor: null,
                    responorganizecode:null,
                    responcode:null,
                    responname:null,
                    msclerkcode:null,
                    msclerkname:null,
                    stype:null,
                },
            }
        },
        watch:{
            $route(to,from){
                this.$store.dispatch('parent2ShowFn');
            }
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
            this.getData();
        },
        methods:{
            getData(){
                var _this=this;
                this.$http.get('/web/store/getStoreByStid',{
                    params:{
                        stid:_this.$route.query.stid
                    }
                }).then(function(res){
                    _this.basicsData=res.data;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            }
        }
    }
</script>
<style scoped>
.hdLiBox{ margin-bottom:20px; }
.hd_li p{ background:#f5f7f9; margin-bottom:5px;  line-height:50px; font-size:14px;}
.hd_li p span{ display:inline-block; width:140px; padding-left:10px; }

h3{ background:#464c5b; color:#fff; line-height:30px; padding-left:20px; }
</style>


// WEBPACK FOOTER //
// src/components/store/seeStore.vue